import { render, staticRenderFns } from "./baseSelectResearchCenterReport.vue?vue&type=template&id=5d07ded2&scoped=true&"
import script from "./baseSelectResearchCenterReport.vue?vue&type=script&lang=ts&"
export * from "./baseSelectResearchCenterReport.vue?vue&type=script&lang=ts&"
import style0 from "./baseSelectResearchCenterReport.vue?vue&type=style&index=0&id=5d07ded2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d07ded2",
  null
  
)

export default component.exports